import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { TranslateModule } from '@ngx-translate/core';
import { LocationSwitchPopupComponent } from '../location-switch-popup/location-switch-popup.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'xplorer-bowser-menu-dropdown',
    templateUrl: './menu-dropdown.component.html',
    styleUrl: './menu-dropdown.component.css',
    imports: [
    NgClass,
    RouterLink,
    LocationSwitchPopupComponent,
    TranslateModule
]
})
export class MenuDropdownComponent implements OnInit {

  isUserLoggedIn: boolean = false;
  isLanguageModalOpen: boolean = false;
  isDropdownOpen: boolean;

  private router: Router = inject(Router);
  private modalService: ModalService = inject(ModalService);
  private authService: AuthService = inject(AuthService);


  ngOnInit(): void {
    this.authService.isUserLogged().subscribe(isLogged => {
      this.isUserLoggedIn = isLogged;
    });
  }

  goToRegister(): void {
    this.router.navigate(['/signup']);
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  onLocationClick() {
    this.openLanguageModal();
  }

  openLanguageModal() {
    this.isLanguageModalOpen = true;
    this.closeDropdownMenu();
  }

  closeDropdownMenu() {
    this.isDropdownOpen = false;
  }

  logout(): void {
    this.isUserLoggedIn = false;
    this.closeDropdownMenu();
    this.authService.logout(`${window.location.origin}/`);
  }

}
